import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { isFunction, __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import { PopoverProvider } from './context.esm.js';
import { usePopover } from './use-popover.esm.js';
export { default as PopoverAnchor } from './PopoverAnchor/index.esm.js';
export { default as PopoverArrow } from './PopoverArrow/index.esm.js';
export { default as PopoverBody } from './PopoverBody/index.esm.js';
export { default as PopoverCloseButton } from './PopoverCloseButton/index.esm.js';
export { default as PopoverContent } from './PopoverContent/index.esm.js';
export { default as PopoverFooter } from './PopoverFooter/index.esm.js';
export { default as PopoverHeader } from './PopoverHeader/index.esm.js';
export { default as PopoverTrigger } from './PopoverTrigger/index.esm.js';

var Popover = function Popover(props) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  var context = usePopover(rest);
  var open = context.open,
      onClose = context.onClose;
  return React__default.createElement(PopoverProvider, {
    value: context
  }, isFunction(children) ? children({
    open: open,
    onClose: onClose
  }) : children);
};

if (__DEV__) {
  Popover.displayName = 'Popover';
}

export default Popover;
//# sourceMappingURL=index.esm.js.map
